<template>
  <div>
    <NuxtLazyHydrate v-if="!init" never>
      <div v-bind="$attrs">
        <slot></slot>
      </div>
    </NuxtLazyHydrate>
    <div v-else v-bind="$attrs">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * This component is used to prevent hydration errors when using LazyHydrate.
 * E.g. "The client-side rendered virtual DOM tree is not matching server-rendered content"
 *
 * This is achieved by rendering, instead of hydrating, the components within.
 */

const init = ref(false)
onMounted(() => {
  if (import.meta.client) init.value = true
})

defineComponent({
  name: 'SafelyHydrate',
  inheritAttrs: false,
})
</script>
